// library imports
import { defineStore } from 'pinia';
import { ref } from 'vue';

/** A single toast notification entry. */
interface Toast {
  id: number;
  message: string;
}

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<Toast[]>([]);
  let nextId = 1;

  /**
   * Display a toast notification that auto-dismisses after the given duration.
   *
   * @param message - Text to display
   * @param duration - Display time in milliseconds (default 2200)
   */
  function show(message: string, duration = 2200) {
    const id = nextId++;
    toasts.value.push({ id, message });
    setTimeout(() => {
      toasts.value = toasts.value.filter(t => t.id !== id);
    }, duration);
  }

  /**
   * Show a standard success toast after an edit drawer saves.
   * Equivalent to show(`${section} updated`, 2200).
   *
   * @param section - Subsection label shown in the toast (e.g. "Legal & Identity", "Phones")
   */
  function showSaved(section: string) {
    show(`${section} updated`, 2200);
  }

  return { toasts, show, showSaved };
});
